// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"9519b55a","703":"6ab3e922","787":"506dd8ed"}[chunkId] + ".chunk.js";
};